import React from "react";
import "./AllocationInfo.css";

const InfoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
    <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeWidth="1.3" />
    <path d="M8 7.2V11" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    <circle cx="8" cy="5" r="0.8" fill="currentColor" />
  </svg>
);

/** Плашка «Распределяется: … · Исходных операций: …» над шагами мастера */
function AllocationInfo({ totalLabel, operationsCount }) {
  return (
    <div className="al-info">
      <InfoIcon />
      <span>
        Распределяется: <strong>{totalLabel}</strong> · Исходных операций:{" "}
        <strong>{operationsCount}</strong>
      </span>
    </div>
  );
}

export default AllocationInfo;
